<tool-drawer-container (openFormDialog)="openDialog()">
  <apr-graduation-summary-form class="form-slot"></apr-graduation-summary-form>

  <tool-header
    class="tool-header"
    headerTitle="APR/Graduation/Summary"
    subtitle="Displays retention and graduation summary by college, department and program"
  ></tool-header>

  <apr-graduation-summary-info-content
    class="main-content"
  ></apr-graduation-summary-info-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'APR/Graduation/Summary'
      )
    "
  ></related-links>
</tool-drawer-container>
